export const PLAN_ACCESS_EVENT = 'forpy:plan-access'

export interface PlanAccessNotice {
  code: 'PLAN_LIMIT_REACHED' | 'PLAN_FEATURE_UNAVAILABLE'
  message: string
  resource?: string
  feature?: string
}

export function parsePlanAccessNotice (value: unknown): PlanAccessNotice | null {
  if (!value || typeof value !== 'object' || !('code' in value) || !('message' in value)) return null
  if ((value.code !== 'PLAN_LIMIT_REACHED' && value.code !== 'PLAN_FEATURE_UNAVAILABLE') || typeof value.message !== 'string') return null
  return {
    code: value.code,
    message: value.message,
    resource: 'resource' in value && typeof value.resource === 'string' ? value.resource : undefined,
    feature: 'feature' in value && typeof value.feature === 'string' ? value.feature : undefined
  }
}

export function notifyPlanAccessNotice (value: unknown): void {
  const notice = parsePlanAccessNotice(value)
  if (notice) window.dispatchEvent(new CustomEvent(PLAN_ACCESS_EVENT, { detail: notice }))
}
